module.exports = __webpack_public_path__ + "img/15-2.bf3f76ff.png";